type Ease = [number, number, number, number]

const easeValues = {
  in: [0.55, 0.06, 0.68, 0.19] as Ease,
  out: [0.22, 0.61, 0.36, 1] as Ease,
  inOut: [0.46, 0.03, 0.52, 0.96] as Ease,
}

export const theme = {
  colors: {
    accent: {
      primary: '#EA6903',
      secondary: '#5C646B',
      rfe: '#EA6903',
    },
  },
  fonts: {
    base: '"Skolar Sans PE", sans-serif',
    headings: '"Skolar Sans PE", sans-serif',
  },
  easeValues,
  ease: Object.keys(easeValues).reduce(
    (acc, key) => ({
      ...acc,
      [key]: `cubic-bezier(${easeValues[key as keyof typeof easeValues].join(
        ', '
      )})`,
    }),
    { in: '', out: '', inOut: '' }
  ),
}
